import { AnomalyTypeAPI, AuditStatus, OrderType } from '@shared';
import { API_ROUTES, request, requestWithPaginationHeader } from '../instance';
import { PartnerAPI } from './partners.service';
import { CourseData } from './courses.service';
import { ExamData } from './exams.service';

export type ExamSessionAPI = {
  examSessionHandle: string;
  auditUuid: string;
  userFirstName: string;
  userLastName: string;
  userEmail?: string | null;
  examStartTime: number[];
  examEndTime: number[];
  examDuration: string;
  shortExam: boolean;
  recordOnlyExam: boolean;
  anomalyCount: number;
  auditStatus: AuditStatus;
  auditOfInterest: boolean;
  failed: boolean;
};

export type PayloadExamSessions = {
  auditOfInterest: boolean;
  auditStatuses: string[];
  anomalyTypes: number[];
  direction: OrderType;
  offset: number;
  field: string;
  limit: number;
};

export const getAnomalyTypesByExamUuid = (examUuid: string, historical = false) => {
  return request<AnomalyTypeAPI[]>({
    url: `${API_ROUTES.apiV1AnomalyTypesByExamUuid(examUuid, historical)}`,
    method: 'GET',
  });
};

export const getAuditStatusesByExamUuid = (examUuid: string) => {
  return request<AuditStatus[]>({
    url: `${API_ROUTES.apiAuditStatusesByExamUuid(examUuid)}`,
    method: 'GET',
  });
};

export const getPack = (
  partner: string,
  course: string,
  exam: string,
  params: PayloadExamSessions
) => {
  return requestWithPaginationHeader<ExamSessionAPI[]>({
    url: `${API_ROUTES.examSessions(exam)}`,
    method: 'POST',
    data: params,
  });
};
type AuditAPI = {
  uuid: string;
  auditType: string;
  startTime: number[];
  endTime: number[];
};
type SessionReviewAPI = {
  partner: PartnerAPI;
  course: CourseData;
  exam: ExamData;
  examSession: {
    uuid: string;
    startTime: number[];
    endTime: number[];
    auditable: boolean;
  };
  user: {
    id: number;
    uuid: string;
    firstName: string;
    lastName: string;
  };
  profileTraceHandle: string;
  documentTraceHandle: string;
  roomScanTraceHandle: string;
  muxedVideoHandle: string;
  streamResponse: {
    handle: string;
    videoStartClock: number;
    videoEndClock: number;
    stateActivity: {
      toState: string;
      timestamp: number;
    }[];
  };
  audits: Array<AuditAPI>;
  auditViews: Array<{
    audit: AuditAPI;
    auditorFullName: string;
  }>;
  anomalyTypeViews: Array<{
    count: number;
    id: number;
    label: string;
  }>;
};

export const getSessionReview = (session: string) => {
  return request<SessionReviewAPI>({
    url: `${API_ROUTES.examSession(session)}`,
    method: 'GET',
  });
};
